export const getStyles = (error: boolean) => ({
  border: `0.063rem solid ${error ? '#BC3838' : '#DCDDE3'}`,
  borderRadius: '0.375rem',
  color: '#4D5163',
  fontSize: '0.875rem',
  fontWeight: 400,
  height: '3rem',
  paddingLeft: '1rem',
  width: '100%',
  minWidth: '200px',
  maxWidth: '100%',
})
